import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { LiaSignInAltSolid } from "react-icons/lia";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useLoginMutation } from "../../redux/api/api";
import { saveLoader } from "../../redux/slice/loaderNoti";

const Auth = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [name, setName] = useState("");
  const [pass, setPass] = useState("");
  const [nameErr, setNameErr] = useState(false);
  const [passErr, setPassErr] = useState(false);
  const [btn, setBtn] = useState(false);

  // RTK QUERY
  const [loginApi] = useLoginMutation();

  const submitHandle = () => {
    if (name?.length == 0 || pass?.length < 8) {
      setNameErr(true);
      setPassErr(true);
    } else {
      setBtn(true);
      let formdata = new FormData();
      formdata.append("username", name);
      formdata.append("password", pass);

      dispatch(saveLoader(true));
      loginApi(formdata)
        .unwrap()
        .then((res) => {
          dispatch(saveLoader(false));
          setBtn(false);
          localStorage.setItem("token", res?.token);
          localStorage.setItem("permissions", JSON.stringify(res?.permissions));
          localStorage.setItem("user_details", JSON.stringify(res?.admin));
          setTimeout(() => {
            navigate("/dashboard");
            window.location.reload();
          }, 1500);
        })
        .catch((err) => {
          dispatch(saveLoader(false));
          setBtn(false);
          console.log("err", err);
        });
    }
  };

  const keydownHandler = (event) => {
    if (event.key == "Enter") {
      submitHandle();
    }
  };

  return (
    <div>
      <div className="hero-static">
        <div className="content">
          <Row className="justify-content-center py-2">
            <Col md={8} lg={6} xl={4} className="py-4">
              <div className="card-login">
                <div className="header-log">
                  <h3>SIGN IN</h3>
                </div>
                <div className="p-3">
                  <div class="p-sm-3 px-lg-4 py-lg-5">
                    <h1 class="h2 mb-1 f2">VOW</h1>
                    <p class="text-muted">Welcome, please login.</p>
                    <div className="py-3">
                      <div className="form-group">
                        <input
                          size="lg"
                          className="form-control-alt form-control form-control-lg"
                          id="username"
                          name="username"
                          placeholder="Username"
                          onChange={(e) => setName(e.target.value)}
                          value={name}
                          onKeyDown={keydownHandler}
                        />
                        {name?.length == 0 && nameErr && (
                          <p className="err">Please enter your username</p>
                        )}
                      </div>
                      <div class="form-group">
                        <input
                          type="password"
                          size="lg"
                          className="form-control-alt form-control form-control-lg"
                          id="password"
                          name="password"
                          placeholder="Password"
                          onChange={(e) => setPass(e.target.value)}
                          value={pass}
                          onKeyDown={keydownHandler}
                        />
                        {pass?.length < 8 && passErr && (
                          <p className="err">Please enter your password</p>
                        )}
                      </div>
                    </div>

                    <Row className="form-group d-flex justify-content-start">
                      <Col md="6" xl="5">
                        <button
                          className={`btn btn-alt-primary f1 btn-alt-primary f1  d-flex gap-2 align-items-center text-nowrap ${
                            btn ? "opacity-50" : ""
                          }`}
                          onClick={() => submitHandle()}
                          disabled={btn}
                        >
                          <LiaSignInAltSolid style={{ fontSize: "20px" }} />
                          Sign In
                        </button>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Auth;
